import { Injectable } from '@angular/core';
import { AuthService } from '@app/auth';
import { Client } from './store/client.store';

@Injectable({
  providedIn: 'root',
})
export class FeatureFlagService {
  constructor(private authService: AuthService) {}

  isFlagEnabled(flag: string): boolean {
    return this.authService.isFindmineUser() && localStorage.getItem(`flag-${flag}`) === 'true';
  }

  isV3EnabledForClient(client: Client | undefined, isAdmin: boolean): boolean {
    if (!client) return false;
    const flags = client.runwayFlags || [];
    const isV3Enabled = (flags.includes('v3_admin') && isAdmin) || (flags.includes('v3_merchandiser') && !isAdmin);

    if (!isV3Enabled && !this.isV4EnabledForClient(client, isAdmin)) {
      return true; // Fallback to v3 if no flags are set
    } else {
      return isV3Enabled;
    }
  }

  isV4EnabledForClient(client: Client | undefined, isAdmin: boolean): boolean {
    if (!client) return false;
    const flags = client.runwayFlags || [];
    return (flags.includes('v4_admin') && isAdmin) || (flags.includes('v4_merchandiser') && !isAdmin) || this.isFlagEnabled('v4');
  }
}
